const NotFoundPage = () => {
  console.log(`react snippet works!`);

  return (
    <>
      <h1 style={{ textAlign: "center" }}>404 ERROR PAGE NOT FOUND</h1>
    </>
  );
};

export default NotFoundPage;
